module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSI4LjMxMyIgdmlld0JveD0iMCAwIDE0IDguMzEzIj4KICA8cGF0aCBpZD0iUGF0aF8xMDE5MSIgZGF0YS1uYW1lPSJQYXRoIDEwMTkxIiBkPSJNLTIuMTg3LTEzLjEyNS0zLjUtMTEuODEyLDIuMTg4LTYuMTI1LTMuNS0uNDM3LTIuMTg3Ljg3NWw3LTdaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjg3NSAzLjUpIHJvdGF0ZSg5MCkiIGZpbGw9IiM3NDgxNzUiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/icon-down-grey.svg
// module id = 2q0o
// module chunks = 1